export default __webpack_public_path__ + "static/media/delievers3.181d697c.jpeg";